<template>
  <div id="google-map"></div>
</template>

<script>
import googleMapInit from './../../lib/google-maps.js'
export default {
  name: 'GoogleMap',
  props: ['lat', 'long', 'zoom', 'title', 'content'],
  async mounted() {
    try {
      // Load the Google Maps
      const google = await googleMapInit()
      // Get the coords from the props
      const coords = { lat: this.lat, lng: this.long }
      // Create the map here and append to the root element
      const map = new google.maps.Map(this.$el, {
        zoom: this.zoom,
      })
      // Center the map on the coords
      map.setCenter(coords)
      // Create the Marker
      const marker = new google.maps.Marker({
        position: coords,
        map,
        title: this.title,
      })
      // Add some content for the info window
      if (this.title && this.content) {
        // Content defined here
        const content = `<div class='marker-label'><h4>${this.title}</h4>
                <div>${this.content}</div></div>`
        // Create the info window
        const infoWindow = new google.maps.InfoWindow({
          content,
        })
        // Open the window on Click
        marker.addListener('click', () => {
          infoWindow.open(map, marker)
        })
      }
    } catch (error) {
      console.log(error)
    }
  },
}
</script>

<style lang='scss'>
#google-map {
  min-height: 400px;
}
.marker-label {
  padding: 8px;
}
</style>